/* ============================================================
   ECHELON Theme — theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ──────────────────────────────────────────────────────────
     Scroll Reveal
  ────────────────────────────────────────────────────────── */
  const reveals = document.querySelectorAll('.reveal');

  if (reveals.length) {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      reveals.forEach((el) => observer.observe(el));
    } else {
      reveals.forEach((el) => el.classList.add('visible'));
    }
  }


  /* ──────────────────────────────────────────────────────────
     Accordions
  ────────────────────────────────────────────────────────── */
  document.querySelectorAll('.accordion-header').forEach((header) => {
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');

    const toggleAccordion = function () {
      const item = header.closest('.accordion-item');
      if (!item) return;

      const isOpen = item.classList.contains('open');
      const accordionScope = item.closest('.accordion-list, .product-info, .faq-page');

      if (accordionScope) {
        accordionScope.querySelectorAll('.accordion-item.open').forEach((openItem) => {
          if (openItem !== item) {
            openItem.classList.remove('open');

            const openHeader = openItem.querySelector('.accordion-header');
            if (openHeader) openHeader.setAttribute('aria-expanded', 'false');
          }
        });
      }

      item.classList.toggle('open', !isOpen);
      header.setAttribute('aria-expanded', String(!isOpen));
    };

    header.addEventListener('click', toggleAccordion);

    header.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleAccordion();
      }
    });
  });


  /* ──────────────────────────────────────────────────────────
     Product Gallery Thumbnails
  ────────────────────────────────────────────────────────── */
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImage = document.querySelector('.product-gallery__main img');

  function updateMainImage(newSrc) {
    if (!mainImage || !newSrc) return;

    mainImage.style.transition = 'opacity 0.2s ease';
    mainImage.style.opacity = '0';

    setTimeout(() => {
      mainImage.src = newSrc;
      mainImage.style.opacity = '1';
    }, 180);
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', function () {
      thumbs.forEach((t) => t.classList.remove('active'));
      this.classList.add('active');

      const newSrc = this.dataset.full || this.querySelector('img')?.src;
      updateMainImage(newSrc);
    });
  });


  /* ──────────────────────────────────────────────────────────
     Product Variant / Color Swatches
  ────────────────────────────────────────────────────────── */
  const swatches = document.querySelectorAll('.color-swatch');
  const colorLabel = document.querySelector('.color-selector__label span');
  const variantSelect = document.querySelector('select[name="id"]');

  const colorMap = {
    'Black': 'Stealth Black',
    'Stealth Black': 'Stealth Black',
    'Arctic Blue': 'Arctic Blue',
    'Court Sage': 'Court Sage'
  };

  function getDisplayColor(rawColor) {
    return colorMap[rawColor] || rawColor;
  }

  function activateVariantCopy(rawColor) {
    const displayColor = getDisplayColor(rawColor);

    document.querySelectorAll('[data-variant-copy]').forEach((item) => {
      item.classList.toggle(
        'active',
        item.dataset.variantCopy === rawColor || item.dataset.variantCopy === displayColor
      );
    });
  }

  function updateColorLabel(rawColor) {
    if (colorLabel) {
      colorLabel.textContent = getDisplayColor(rawColor);
    }
  }

  function updateVariantSelect(variantId) {
    if (!variantSelect || !variantId) return;

    variantSelect.value = variantId;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  swatches.forEach((swatch) => {
    swatch.addEventListener('click', function () {
      swatches.forEach((s) => s.classList.remove('active'));
      this.classList.add('active');

      const rawColor = this.dataset.colorName;
      const variantId = this.dataset.variantId;
      const newImage = this.dataset.image;

      updateColorLabel(rawColor);
      activateVariantCopy(rawColor);
      updateVariantSelect(variantId);

      if (newImage) {
        updateMainImage(newImage);
      }
    });
  });

  const initialColor =
    document.querySelector('.color-swatch.active')?.dataset.colorName ||
    document.querySelector('[data-variant-copy]')?.dataset.variantCopy;

  if (initialColor) {
    updateColorLabel(initialColor);
    activateVariantCopy(initialColor);
  }


  /* ──────────────────────────────────────────────────────────
     Homepage Color Cards
     Note: current homepage variant section uses linked cards.
     This keeps compatibility if older .variant-card markup exists.
  ────────────────────────────────────────────────────────── */
  const variantCards = document.querySelectorAll('.variant-card');
  const variantLabel = document.querySelector('.variant-selected-label');

  variantCards.forEach((card) => {
    card.addEventListener('click', function () {
      variantCards.forEach((c) => c.classList.remove('active'));
      this.classList.add('active');

      if (variantLabel) {
        variantLabel.textContent = this.dataset.variantLabel || '';
      }
    });
  });


  /* ──────────────────────────────────────────────────────────
     Add to Cart
  ────────────────────────────────────────────────────────── */
  const productForm = document.querySelector('form[action*="/cart/add"], form[data-product-form]');
  const addToCartBtn = document.querySelector('.btn-add-to-cart');

  if (productForm && addToCartBtn) {
    productForm.addEventListener('submit', async function (event) {
      event.preventDefault();

      const variantId =
        document.querySelector('.color-swatch.active')?.dataset.variantId ||
        document.querySelector('select[name="id"]')?.value;

      if (!variantId) {
        alert('Please select a color before adding to cart.');
        return;
      }

      const originalText = addToCartBtn.textContent;
      addToCartBtn.textContent = 'ADDING...';
      addToCartBtn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        addToCartBtn.textContent = '✓ ADDED TO CART';

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        let countEl = document.querySelector('.cart-count');
        const cartLink = document.querySelector('.header-cart');

        if (!countEl && cartLink) {
          countEl = document.createElement('span');
          countEl.className = 'cart-count';
          cartLink.appendChild(countEl);
        }

        if (countEl) {
          countEl.textContent = cart.item_count;
        }

        setTimeout(() => {
          addToCartBtn.textContent = originalText || 'PRE-ORDER APEX';
          addToCartBtn.disabled = false;
        }, 2200);

      } catch (error) {
        console.error(error);
        addToCartBtn.textContent = 'TRY AGAIN';
        addToCartBtn.disabled = false;

        setTimeout(() => {
          addToCartBtn.textContent = originalText || 'PRE-ORDER APEX';
        }, 1800);
      }
    });
  }


  /* ──────────────────────────────────────────────────────────
     Email Capture
     Important: Do NOT prevent default.
     Let Shopify submit/save the customer email.
  ────────────────────────────────────────────────────────── */
  document.querySelectorAll('.email-form').forEach((emailForm) => {
    emailForm.addEventListener('submit', function () {
      const btn = this.querySelector('button');
      const email = this.querySelector('input[type="email"]')?.value;

      if (btn) {
        btn.textContent = 'JOINING...';
        btn.disabled = true;
      }

      if (email) {
        document.dispatchEvent(
          new CustomEvent('echelon:email-captured', {
            detail: { email: email }
          })
        );
      }
    });
  });


  /* ──────────────────────────────────────────────────────────
     Mobile Menu
  ────────────────────────────────────────────────────────── */
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const navLinks = document.querySelector('.nav-links');

  if (mobileToggle && navLinks) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = navLinks.classList.toggle('mobile-open');

      this.classList.toggle('open', isOpen);
      this.setAttribute('aria-expanded', String(isOpen));
      this.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('mobile-menu-open', isOpen);
    });

    navLinks.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', function () {
        navLinks.classList.remove('mobile-open');
        mobileToggle.classList.remove('open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileToggle.setAttribute('aria-label', 'Open menu');
        document.body.classList.remove('mobile-menu-open');
      });
    });
  }


  /* ──────────────────────────────────────────────────────────
     Sticky Header Shadow on Scroll
  ────────────────────────────────────────────────────────── */
  const header = document.querySelector('.site-header');

  if (header) {
    const updateHeaderBorder = () => {
      header.style.borderBottomColor = window.scrollY > 10 ? '#ddd' : '#e5e5e5';
    };

    updateHeaderBorder();

    window.addEventListener('scroll', updateHeaderBorder, { passive: true });
  }

});

/* ============================================================
   ECHELON Product Variant Color Selection Fix
   Ensures selected paddle color is added to cart
   ============================================================ */

(function () {
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;

  const variantInput =
    productForm.querySelector('input[name="id"]') ||
    document.querySelector('input[name="id"]');

  const colorButtons = document.querySelectorAll(
    '[data-variant-id], .color-swatch, .variant-card'
  );

  if (!variantInput || !colorButtons.length) return;

  function clearActiveStates() {
    colorButtons.forEach(function (button) {
      button.classList.remove('active', 'is-active', 'selected');
      button.setAttribute('aria-pressed', 'false');
    });
  }

  colorButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const variantId =
        button.getAttribute('data-variant-id') ||
        button.dataset.variantId;

      if (!variantId) return;

      variantInput.value = variantId;

      clearActiveStates();

      button.classList.add('active');
      button.setAttribute('aria-pressed', 'true');

      const selectedLabel = document.querySelector('[data-selected-color-label]');
      const colorName =
        button.getAttribute('data-color') ||
        button.getAttribute('title') ||
        button.textContent.trim();

      if (selectedLabel && colorName) {
        selectedLabel.textContent = colorName;
      }
    });
  });
})();